import {
  action,
  computed,
  makeObservable,
  observable,
  ObservableMap,
  observe,
  runInAction,
} from 'mobx';
import { AuthApi } from '../api/auth.api';
import { IService } from '../interfaces/service.interface';
import RootStore from './RootStore';

export default class ServiceStore {
  private rootStore: RootStore;

  @observable service: IService | undefined;
  @observable categories: ObservableMap<number, string> = observable.map();

  @computed
  get showCompleteButton(): boolean {
    // return this.service ? this.service.useType === 1 : false;
    return true;
  }

  @computed
  get isUseType1(): boolean {
    return this.service ? this.service.useType === 1 : false;
  }

  @action
  fetchServiceData = async () => {
    if (!this.service) {
      const res = await AuthApi.getService();
      runInAction(() => {
        this.service = res;
        this.categories = observable.map();
        Object.entries(this.service.categories).forEach(([k, v]) => {
          this.categories.set(Number(k), v);
        });
      });
    }
  };

  @action
  getCategoryName = (categoryId: number): string => {
    return this.categories.get(categoryId) || '';
  };

  @action
  getHonorificTitle = (): string => {
    return this.service ? (this.service.useType === 1 ? '様' : '') : '';
  };

  @action
  observeService = async (change: any) => {
    this.service = change.newValue as IService;
  };

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this);
    observe(this, 'service', this.observeService);
  }
}
